import { IToast } from '@chakra-ui/react';

export type MessagesToast =
	| 'MSG_PLANNING_TABLE_UPDATED_SUCCESS'
	| 'MSG_PLANNING_TABLE_UPDATED_ERROR';

export const planningTableMessagesToast: Record<MessagesToast, IToast> = {
	MSG_PLANNING_TABLE_UPDATED_SUCCESS: {
		title: 'Plano atualizado com sucesso!',
		status: 'success',
	},
	MSG_PLANNING_TABLE_UPDATED_ERROR: {
		title: 'Erro ao atualizar plano!',
		status: 'error',
	},
};
